import React from 'react';
import ClassComponent from '../../components/ClassComponent';
import { useTranslation } from 'react-i18next';
import {
  VStack,
  Text,

} from '@chakra-ui/react';
import { Loader } from '../../../../components/Loader';
import { usePublicProgramsQuery } from '../../../../generated/graphqlModels';

interface Program {
  id: string;
  name: string;
  description: string;
  image?: {
    url: string;
  };
}

const FreePrograms: React.FC = () => {
  const { t } = useTranslation();
  const { data, loading, error } = usePublicProgramsQuery();
  console.log("free programs data: ", data);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Text color="red.500">
        {t('error.loadingPrograms')}
      </Text>
    );
  }
  console.log('in program free')

  return (
    <VStack
		  align="start"
		  gap="4"
		  w="full"
		  borderTop="1px solid #E0E0E0"
		  marginTop="20px"
		  paddingTop="20px"
		>
      <VStack gap="2" w="full" align="start">
        {data?.programs.map((program: Program) => (
          <ClassComponent
					  key={program.id}
					  showInfo={true}
					  to={`/program/${program.id}?public=true`}
					  {...program}
					  sameHeight={false}
					  enabled={true}
					  name={`${program.name}`}
					/>
        ))}
      </VStack>

      {data?.programs.length === 0 && (
        <Text textAlign="center" fontSize="lg">
          {t('freePrograms.noPrograms')}
        </Text>
      )}
    </VStack>
  );
};

export default FreePrograms;
